exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SchoolContestPreference .classSection{margin-bottom:40px}.SchoolContestPreference span{display:block;font-weight:700}.SchoolContestPreference label{margin-right:30px;margin-bottom:15px;width:35%}.SchoolContestPreference .saveAction{text-align:right;margin-right:10%}.SchoolContestPreference .dateSection,.SchoolContestPreference .metricSection{padding-left:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/preferences/school_contest_preference.scss
// module id = 1331
// module chunks = 0